/** HPRD: hours of care per resident per day. Replaces the Staffing Ratio (card 255). */

export const UNDERSTAFFED_HPRD = 2.0;
export const OVERSTAFFED_HPRD = 3.5;

export type HprdLevel = 'UNDERSTAFFED' | 'NORMAL' | 'OVERSTAFFED';

export const HPRD_TOOLTIP =
  'Hours of care per resident per day: the hours worked by staff in valid positions, divided by the number of residents. Under 2.0 is understaffed, 2.0 to 3.5 is normal, over 3.5 is overstaffed.';

export const RATIO_TOOLTIP =
  'Number of residents per staff member providing direct care';

const round2 = (value: number) => Math.round(value * 100) / 100;

export const hprdLevel = (value: number): HprdLevel => {
  const rounded = round2(value);

  if (rounded < UNDERSTAFFED_HPRD) return 'UNDERSTAFFED';
  if (rounded > OVERSTAFFED_HPRD) return 'OVERSTAFFED';

  return 'NORMAL';
};

export const formatHprd = (value: number | null | undefined): string =>
  value === null || value === undefined ? 'N/A' : value.toFixed(2);

/** A move is unhealthy when it takes an already out-of-range value further out. */
export const isHprdUnhealthy = (value: number, delta: number): boolean => {
  const level = hprdLevel(value);

  if (level === 'OVERSTAFFED') return delta > 0;
  if (level === 'UNDERSTAFFED') return delta < 0;

  return false;
};

export const hprdStatus = (
  value: number | null
): { label: string; className: string } | null => {
  if (value === null) return null;

  const level = hprdLevel(value);

  if (level === 'NORMAL') {
    return {
      label: 'Normal',
      className: 'border-polar-green-6 bg-polar-green-1 text-polar-green-7',
    };
  }

  return {
    label: level === 'UNDERSTAFFED' ? 'Understaffed' : 'Overstaffed',
    className: 'border-dust-red-5 bg-dust-red-1 text-dust-red-5',
  };
};
